import { Tag } from '../constants';
import { defaultFactory as request } from '../api/RequestFactory';
import FSA from './FSA';

function fetchTags(requesterId: string, query): any {
    return request.get('customer/tag', query);
}

export function listTags(requesterId: string, query?): any {
    return dispatch => {
        dispatch(new FSA(Tag.FETCH_REQUEST).addMeta({ requesterId, query }).data);

        return fetchTags(requesterId, query).then(nodes => {
            return dispatch(new FSA(Tag.FETCH_SUCCESS).addPayload(nodes).addMeta({ requesterId, query }).data);
        }, err => {
            dispatch(new FSA(Tag.FETCH_FAILURE).addError(err).addMeta({ requesterId, query }).data);
            throw err;
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/Tag.ts